import { useEffect, useState } from "react";
import { useI18n } from "@/lib/i18n";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { HelpCircle, ShoppingCart, Users } from "lucide-react";

export default function FaqPage() {
  const { t, language } = useI18n();
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("shop");

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(console.error).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64 text-muted-foreground">{t("common.loading")}</div>;

  const shopFaqs = faqs.filter((f) => !f.category || f.category === "shop");
  const affFaqs = faqs.filter((f) => f.category === "affiliate");
  const filtered = tab === "shop" ? shopFaqs : affFaqs;

  return (
    <div className="space-y-6" data-testid="faq-page">
      <div className="flex items-center gap-3">
        <HelpCircle className="w-6 h-6 text-blue-500" />
        <h1 className="text-2xl font-bold">FAQ</h1>
      </div>

      <div className="flex gap-2">
        <button onClick={() => setTab("shop")} className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${tab === "shop" ? "bg-blue-600 text-white" : "bg-accent/50 text-muted-foreground hover:text-foreground"}`} data-testid="faq-tab-shop">
          <ShoppingCart className="w-3.5 h-3.5" />{t("faq.tab_shops")}
          <Badge variant="secondary" className="text-xs ml-1">{shopFaqs.length}</Badge>
        </button>
        <button onClick={() => setTab("affiliate")} className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${tab === "affiliate" ? "bg-emerald-600 text-white" : "bg-accent/50 text-muted-foreground hover:text-foreground"}`} data-testid="faq-tab-affiliate">
          <Users className="w-3.5 h-3.5" />{t("faq.tab_affiliate")}
          <Badge variant="secondary" className="text-xs ml-1">{affFaqs.length}</Badge>
        </button>
      </div>

      {filtered.length === 0 ? (
        <p className="text-muted-foreground py-8 text-center">Geen FAQ's beschikbaar voor deze categorie.</p>
      ) : (
        <Accordion type="single" collapsible className="space-y-3">
          {filtered.map((faq, i) => (
            <AccordionItem key={faq.id} value={`faq-${i}`} className="bg-card border border-border rounded-xl px-6" data-testid={`dashboard-faq-${i}`}>
              <AccordionTrigger className="text-left font-semibold hover:text-blue-500 py-5">
                {faq.question?.[language] || faq.question?.nl || ""}
              </AccordionTrigger>
              <AccordionContent className="pb-5">
                <div className="text-sm text-muted-foreground leading-relaxed" dangerouslySetInnerHTML={{ __html: faq.answer?.[language] || faq.answer?.nl || "" }} />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      )}
    </div>
  );
}
